import{dialogContentPropDefs as e}from"./dialog.props.js";export{e as alertDialogContentPropDefs};
//# sourceMappingURL=alert-dialog.props.js.map
